import { Flex } from '@chakra-ui/react'
import { useVideoBlob } from '../../../components/VideoPlayer/useVideoBlob'

interface TutorialAssessmentPIProps {
  urlVideo: string
  urlPoster?: string
  Titulo: string
  Descricao: string
}

export const TutorialVideoPI: React.FC<TutorialAssessmentPIProps> = ({
  urlVideo,
  urlPoster,
  Titulo,
  Descricao
}) => {
  const { src, progresso } = useVideoBlob(urlVideo, true)

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      pos="relative"
      gap="2rem"
      margin="2rem auto"
      pr="2rem"
    >
      <Flex
        direction="column"
        justifyContent="center"
        alignItems="center"
        pos="relative"
        gap="2rem"
        margin="0 auto"
        pr="2rem"
      >
        <Flex
          flexDir="column"
          gap=".75rem"
          alignItems="center"
          textAlign="center"
        >
          <h1>{Titulo}</h1>
          <p>{Descricao}</p>
        </Flex>

        <video
        key={urlVideo}
          width="60%"
          autoPlay
          loop
          muted
          controls
          poster={urlPoster}
          src={src}
        >
          Seu navegador não suporta vídeos.
        </video>
        {!src && <small>Carregando vídeo{progresso !== null ? `... ${progresso}%` : '...'}</small>}
      </Flex>
    </Flex>
  )
}

export default TutorialVideoPI
